import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { selectAllStrings } from '../features/language/languageSlice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import '../stylesheets/ConfirmModal.css';

const ConfirmModal = ({title, message, onClose}) => {
    const strings = useSelector(selectAllStrings);
    const history = useHistory();
    
    return (<div className="modal" id="confirm_modal">
        <div className="modal-body" id="confirm_modal_body">
            <div className="modal-content">
                <div className="modal-header">
                    <span>{strings.thank_you}</span>
                    <hr/>
                </div>
                <div className="icon">
                    <FontAwesomeIcon icon={faCheckCircle}/>
                </div>
                <div className="modal-title">{title}</div>
                <div className="modal-text">{message}</div>
                <button className="btn" id="close_button" onClick={event => {
                event.preventDefault();
                onClose();
            }}>{strings.close}</button>
    
            </div>
        </div>
    </div>);
};

export default ConfirmModal;